import './index.scss';

import React from "react";
import Label from "../../atoms/label";
import {price} from "../../../util/formatting";

class CartShippingNotice extends React.Component {
    static defaultProps = {
        cart: null,
    };
    
    constructor(props) {
        super(props);
    }
    
    render() {
        let fulfillment_details = this.props.cart.fulfillment_details;
        
        if (!fulfillment_details.method) {
            return null;
        }
        
        return (
            <div className={'cart-shipping-notice'}>
                <div className="cart-shipping-notice__label">
                    <Label title="Pre-order"/>
                </div>
                <div className="list-item__column list-item__column--valign-top list-item__column--clean list-item__column--span-5">
                    {fulfillment_details.method} — {fulfillment_details.description}
                </div>
                <div className="list-item__column list-item__column--span-2">
                    <span className="list-item__price">{price(fulfillment_details.total)}</span>
                </div>
                <div className="list-item__column list-item__column--span-2">
                    &nbsp;
                </div>
            </div>
        );
    }
}

export default CartShippingNotice;